import type { StockSearchBrief } from "../../global/GlobalType";

/** 是否在港美股清单中 */
export function isOverseasStockCode(
  code: string,
  overseasCatalog: StockSearchBrief[]
): boolean {
  const c = code.trim().toUpperCase();
  if (!c) {
    return false;
  }
  return overseasCatalog.some((s) => String(s.code ?? "").trim().toUpperCase() === c);
}

export function marketRegionOfCode(
  code: string,
  overseasCatalog: StockSearchBrief[]
): string | undefined {
  const c = code.trim().toUpperCase();
  const hit = overseasCatalog.find((s) => String(s.code ?? "").trim().toUpperCase() === c);
  return hit?.marketRegion;
}
